export default __webpack_public_path__ + "static/media/Achievement_Ribbon.58411b7e.jpg";